// src/heroImages.js
//
// Hero background photos for each page. All images are from Unsplash and
// used under the Unsplash License (free for commercial + noncommercial use,
// no attribution required — https://unsplash.com/license).
//
// Hotlinked directly from images.unsplash.com, which is Unsplash's own CDN
// and is designed for this kind of use. If you'd rather self-host them,
// download each URL and swap the value for a local path (e.g. `/images/hero-home.jpg`).

const HERO_IMAGES = {
  home: 'https://images.unsplash.com/photo-1770885653473-ca48b4d69173?fm=jpg&q=80&w=2400&auto=format&fit=crop',
  services: 'https://images.unsplash.com/photo-1765046255505-083da4b856c8?fm=jpg&q=80&w=2400&auto=format&fit=crop',
  portfolio: 'https://images.unsplash.com/photo-1758873268745-dd2cf0d677b5?fm=jpg&q=80&w=2400&auto=format&fit=crop',
  pricing: 'https://images.unsplash.com/photo-1761888855526-674732099103?fm=jpg&q=80&w=2400&auto=format&fit=crop',
  about: 'https://images.unsplash.com/photo-1758216434916-0819f9cd3a4d?fm=jpg&q=80&w=2400&auto=format&fit=crop',
  careers: 'https://images.unsplash.com/photo-1758873269276-9518d0cb4a0b?fm=jpg&q=80&w=2400&auto=format&fit=crop',
  contact: 'https://images.unsplash.com/photo-1763386599808-276b60c4bc76?fm=jpg&q=80&w=2400&auto=format&fit=crop',
};

export default HERO_IMAGES;